<template>
  <div v-if="notes.length>0" class="notes grid-12 column label">
    <br />
    <br />
    <div class="title">Anotações</div>
    <div class="container">
      <div class="row note column-s" v-for="(note, key) in notes" :key="`note-${key}`">
        <template v-if="note.criado_por===user.id">
          <div class="grid-5 grid-12-s"></div>
          <div class="grid-7 grid-8-m grid-11-s">
            <div class="align-end justify-end row column-s">
              <b>{{new Date(note.criado_em).toLocaleDateString().substring(0,5)}} às {{new Date(note.criado_em).toLocaleTimeString()}}</b>
              -
              {{note.nome_criado_por}}
            </div>
            <div class="textarea textarea-silver">{{note.nota}}</div>
          </div>
        </template>
        <template v-else>
          <div class="grid-7 grid-11-s">
            <b>{{new Date(note.criado_em).toLocaleDateString().substring(0,5)}} às {{new Date(note.criado_em).toLocaleTimeString()}}</b>
            -
            {{note.nome_criado_por}}
            <div class="textarea textarea-gold">{{note.nota}}</div>
          </div>
          <div class="grid-5 grid-12-s"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Notes",
  props: {
    notes: {
      type: Array
    }
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.notes {
  margin-top: 33px;
  .container {
    background: $white-9;
    border-radius: 12px;
    padding: 15px;
    border: 1px solid $white-6;
  }
  .title {
    font-size: 20px;
    font-weight: 400;
  }
  .note {
    margin-top: 15px;
    color: $gray-5;

    .textarea {
      box-shadow: none;
      padding: 15px;
      margin-top: 8px;

      @media (min-width: $small) {
        border-radius: 30px;
      }
    }
    .textarea-gold {
      height: auto;
    }
    .textarea-silver {
      height: auto;
      background: $white-5;
    }
  }
}
</style>